import React, { useEffect } from "react"; 
import { BrowserRouter } from "react-router-dom";
import MainRoute from "./Routes/MainRoutes";
import AppContextProvider from "./context/AppContext";
import { LocalizationProvider } from "@mui/x-date-pickers";  
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { createTheme, ThemeProvider } from "@mui/material";

function App() {
  // 130845 54 112
  useEffect(() => {
    const handleWheel = (e) => {
      // Only prevent default behavior if a number input is focused
      if (document.activeElement.type === 'number' && e.target === document.activeElement) {
        e.preventDefault();
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const tableTheme = createTheme(
   {
    // palette: {
    //   mode: "light", //let's use the same dark/light mode as the global theme
    //   // primary: "primary", //swap in the secondary color as the primary for the table
    //   info: {
    //     main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
    //   },
    //   background: {
    //     default: "#212631", //pure black table in dark mode for fun
    //   },
    // },
    // typography: {
    //   button: {
    //     textTransform: "none", //customize typography styles for all buttons in table by default
    //     fontSize: "1.2rem",
    //   },
    // },
    // components: {
    //   MuiTooltip: {
    //     styleOverrides: {
    //       tooltip: {
    //         fontSize: "1.1rem", //override to make tooltip font size larger
    //       },
    //     },
    //   },
    //   MuiSwitch: {
    //     styleOverrides: {
    //       thumb: {
    //         color: "pink", //change the color of the switch thumb in the columns show/hide menu to pink
    //       },
    //     },
    //   },
    // },
  }
// {}
);

  return (
    <BrowserRouter>
      <ThemeProvider theme={tableTheme}>
        <AppContextProvider>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <MainRoute />
          </LocalizationProvider>
        </AppContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
